module.exports = __webpack_public_path__ + "cristmas.e1939c52180541130df1.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/line-icons-pro/christmas/webfont/cristmas.svg
// module id = ../../../../../src/assets/fonts/line-icons-pro/christmas/webfont/cristmas.svg
// module chunks = styles